import clsx from 'clsx';
import React from 'react';

export default function Divider({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement> & { className?: string }) {
  return <div className={clsx('w-full h-[1px] bg-[#eee]', className)} {...props} />;
}
